var map = {
	"./NewsSection/Benzinga.png": 47363,
	"./NewsSection/DigitalJournal.png": 26656,
	"./NewsSection/SCOWWDOTROA.jpeg": 78864,
	"./NewsSection/TechBullion-colored-logo.png": 45519,
	"./NewsSection/TrendNewsAgency.jpeg": 64017,
	"./NewsSection/ZEXPRWIRE.png": 98649,
	"./NewsSection/azertag.png": 38529,
	"./apartment-service-icon.png": 55726,
	"./app-showcase-mockup.mp4": 27529,
	"./check-mark.png": 226,
	"./cleaning-service-icon.png": 44233,
	"./club-service-icon.png": 21242,
	"./driver-service-icon.png": 98524,
	"./gold-logo-transparent.png": 48217,
	"./gold-logo.png": 93560,
	"./hero-section-img.png": 4724,
	"./instagram-icon.png": 61474,
	"./logo.png": 33153,
	"./main.css": 30010,
	"./mockaup.webp": 8319,
	"./partners/amber-logo.png": 93657,
	"./partners/bagatelle-logo.png": 29323,
	"./partners/big-yellow-storage-logo.png": 24933,
	"./partners/chinois-logo.png": 45655,
	"./partners/cuckoo-logo.png": 77664,
	"./partners/ihateironing-logo.png": 48391,
	"./partners/johnsco-logo.png": 80702,
	"./partners/maddox-logo.png": 26605,
	"./partners/pirana-logo.png": 84567,
	"./partners/qatar-airways-logo.png": 51194,
	"./partners/reign-logo.png": 19547,
	"./partners/sumosan-logo.png": 87172,
	"./partners/tabu-logo.png": 43626,
	"./party-bg.mp4": 84092,
	"./private-service-icon.png": 36251,
	"./red-party-bg.mp4": 74326,
	"./reviewer-1-pic.jpg": 37040,
	"./reviewer-2-pic.png": 44351,
	"./reviewer-3-pic.jpg": 57146,
	"./reviewer-4-pic.jpg": 76049,
	"./talab-chat-mockup.webp": 25010,
	"./talab-explore-mockup.webp": 47301,
	"./talab-service-mockup.webp": 25897,
	"./tiktok-icon.webp": 69259,
	"./trustpilot.png": 97292,
	"./university-service-icon.png": 91078,
	"./user-profile-icon.png": 95291,
	"./welcome-screen-mockup.webp": 57906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;